<template>
  <div id="app">
    <router-view/>
    <!-- <to-watch-list v-if="currentName !=='List' "></to-watch-list> -->
  </div>
</template>
<style lang="scss">
</style>
<script>

export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {},
}
</script>
